import { useSearchParams } from "react-router-dom";
import { scroll } from "src/components/common/functions";

export default function ServerFooter({
    length,
    parentId,
    paginateAction,
    pageSelectId,
    pagination,
    loading = false,
    pa = "position-absolute"
}:{
    length: number, 
    parentId?: string, 
    paginateAction?: Function, 
    pageSelectId?: string, 
    pagination?: { page: number; limit: number; onChange: (page: number, limit: number) => void };
    loading?: boolean;
    pa?: string
}) {
    const [searchParams, setSearchParams] = useSearchParams();
    const page  = pagination?.page ?? Number(searchParams.get("page") ?? 1);
    const limit = pagination?.limit ?? Number(searchParams.get("limit") ?? 10);
    const totalPages = Math.ceil(length / limit);
    const pageNumbers = Array.from({ length: totalPages }, (_, i) => i + 1);
    // ----------------------------------------------------
    const updateParams = (nextPage: number, nextLimit = limit) => {
        if (pagination) {
            pagination.onChange(nextPage, nextLimit);
            paginateAction?.();
            return;
        }
        const params = new URLSearchParams(searchParams);
        params.set("page", String(nextPage));
        params.set("limit", String(nextLimit));
        setSearchParams(params, { replace: false });
        paginateAction?.();
        scroll(parentId ?? null);
    };

    // ----------------------------------------------------
    return (
        <footer className={`w-100 ${pa}`}>
            <nav className="d-flex justify-content-end px-4 pt-3">
                <div className="overflow-auto">
                    <ul className="pagination mb-0 d-flex cssPage">
                        {pageNumbers.map(p => (
                            <li key={p} className="page-item">
                                <button
                                    type = "button"
                                    disabled={loading}
                                    aria-current={page === p ? "page" : undefined}
                                    onClick = {() => updateParams(p)}
                                    className = {`page-link paginationOutline ${
                                        page === p ? "active" : ""
                                    }`}
                                >
                                    {p}
                                </button>
                            </li>
                        ))}
                    </ul>
                </div>
            </nav>

            <div className="text-nowrap mt-3 pe-4 d-flex justify-content-end align-items-center">
                <span>Total: {length}</span>

                <select
                    id = {`pageSelect-${pageSelectId ?? "main"}`}
                    className = "form-select d-inline pageNumberSelectWidth ms-3"
                    aria-label="Per page"
                    disabled={loading}
                    value = {limit}
                    onChange = {e =>
                        updateParams(1, Number(e.currentTarget.value))
                    }
                >
                    {[1, 5, 10, 20, 50, 100].map(n => (
                        <option key = {n} value = {n}>{n}</option>
                    ))}
                </select>
            </div>
        </footer>
    );
}
